(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omvello-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  if (preference.matches || !('IntersectionObserver' in window) || typeof Element.prototype.animate !== 'function') return;
  const running = new Set();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting || preference.matches) continue;
      observer.unobserve(entry.target);
      const animation = entry.target.animate([{ transform: 'translateY(32px)', opacity: .5 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 650, easing: 'cubic-bezier(.16,1,.3,1)' });
      running.add(animation);
      animation.finished.then(() => running.delete(animation), () => running.delete(animation));
    }
  }, { threshold: .12 });
  const initialize = root => root.querySelectorAll('.om-product, .om-section-heading, .om-story-copy, .om-note > div').forEach(node => {
    if (node.dataset.omMotion || preference.matches) return;
    node.dataset.omMotion = 'ready';
    if (node.getBoundingClientRect().top >= innerHeight) observer.observe(node);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  preference.addEventListener('change', () => {
    if (!preference.matches) return;
    observer.disconnect();
    for (const animation of running) animation.finish();
    running.clear();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
